<template>
  <footer class="layout-footer">
    <EnterConsultation></EnterConsultation>
    <div class="footerbackground">
      <div class="container">
        <div>
          <ul class="l" v-if="homeContent">
            <li class="contact">{{ homeContent.mainTitle }}</li>
            <li>
              电话：<i>{{ homeContent.phone }}</i>
            </li>
            <li>邮箱：{{ homeContent.emile }}</li>
            <li>地址：{{ homeContent.adress }}</li>
          </ul>
          <!-- 底部二维码区域 -->
          <div class="qr-group">
            <div class="qr-item">
              <img :src="follow" alt="二维码1" />
              <p>扫一扫 关注我们吧！</p>
            </div>
            <div class="qr-item">
              <img :src="follow" alt="二维码2" />
              <p>扫一扫 关注我们吧！</p>
            </div>
          </div>
          <div class="footer-nav" style="display: flex; width: 651px">
            <a href="/productCenter">产品中心</a>
            <a href="/newsUpdates">新闻动态</a>
            <a href="/Customer">客户案例</a>
            <a href="/contactUs">关于我们</a>
          </div>
        </div>
        <div class="right-col">
          <el-form
            ref="demandForm"
            :model="resetForm"
            :rules="formRules"
            label-width="0"
            class="demand-form"
          >
            <el-form-item prop="demandContent">
              <el-input
                type="textarea"
                placeholder="在线需求"
                v-model="resetForm.demandContent"
                :rows="3"
              ></el-input>
            </el-form-item>
            <div class="checkbox-container">
              <div
                class="center-card"
                v-for="(item, index) in homeMessage.list"
                :key="index"
              >
                <div class="center-title" v-model="item.tabTitle" >
                  {{ item.tabTitle }}
                </div>
                <div
                  class="checkbox-item"
                  v-for="(issue, issueIndex) in item.list"
                  :key="issueIndex"
                >
                  <input
                    type="checkbox"
                    v-model="issue.checked"
                    :true-value="true"
                    :false-value="false"
                  />
                  {{ issue.impront }}
                </div>
              </div>
            </div>
            <div class="information">
              <!-- 姓名 -->
              <el-form-item prop="linkman">
                <el-input
                  v-model="resetForm.linkman"
                  placeholder="姓名"
                ></el-input>
              </el-form-item>

              <!-- 公司名称 -->
              <el-form-item prop="companyName">
                <el-input
                  v-model="resetForm.companyName"
                  placeholder="公司名称"
                ></el-input>
              </el-form-item>

              <!-- 联系方式（手机号校验） -->
              <el-form-item prop="contactInfo">
                <el-input
                  v-model="resetForm.contactInfo"
                  placeholder="联系方式"
                ></el-input>
              </el-form-item>
              <!-- 提交按钮 -->
              <el-button
                type="primary"
                @click="submit"
                style="background: #005cef; border-radius: 4px 4px 4px 4px"
                >提交需求</el-button
              >
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <div class="copyright">
      版权所有 Copyright © 1999-2029 温州浩瑞网络科技有限公司 浙ICP备15039737号
    </div>
  </footer>
</template>

<script>
import follow from "../../assets/follow.png";
import EnterConsultation from "./EnterConsultation";
import { insert, getConf } from "../../api/article";

export default {
  name: "Footer",
  components: {
    EnterConsultation,
  },
  data() {
    return {
      tabTitle: "",
      checked: false,
      homeMessage: { list: [{ list: [] }] },
      homeContent: {
        mainTitle:"",
      },
      follow,
      resetForm: {
        demandContent: "", // 需求内容
        linkman: "", // 姓名
        companyName: "", // 公司名称
        contactInfo: "", // 联系方式（手机号）
      },
      isSubmitting: false,
      // 关键：表单校验规则
      formRules: {
        demandContent: [
          { required: true, message: "请输入在线需求", trigger: "blur" },
        ],
        linkman: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        contactInfo: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/, // 手机号正则
            message: "请输入正确的手机号格式",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.fetchHomeConf();
  },
  methods: {
      async fetchHomeConf() {
        try {
          const response = await getConf();

          this.homeContent = JSON.parse(response.data.content);

          const rawHomeMessage = JSON.parse(response.data.message);

          // 确保 rawHomeMessage.list 是数组，否则用空数组替代
          const rawList = Array.isArray(rawHomeMessage?.list) ? rawHomeMessage.list : [];

          this.homeMessage = {
            ...rawHomeMessage,
            list: rawList.map((group) => ({
              ...group,
              list: Array.isArray(group?.list)
                ? group.list.map((issue) => ({
                    ...issue,
                    checked: issue.checked ?? false,
                  }))
                : [],
            })),
          };
          
        } catch (error) {
          console.error("页面初始化获取配置失败", error);
        }
      },
    // 统计所有勾选的选项数量
    getCheckedCount() {
      let count = 0;
      // 遍历所有选项组
      this.homeMessage.list.forEach((item) => {
        // 遍历每组的选项，统计checked为true的数量
        item.list.forEach((issue) => {
          if (issue.checked) count++;
        });
      });
      return count;
    },
    // 新增：获取每个tabTitle下勾选的内容
    getCheckedDetails() {
      const checkedDetails = {};
      this.homeMessage.list.forEach((item) => {
        const tabTitle = item.tabTitle;
        const checkedItems = item.list
          .filter((issue) => issue.checked)
          .map((issue) => issue.impront); // 收集勾选的选项内容
        if (checkedItems.length > 0) {
          checkedDetails[tabTitle] = checkedItems;
        }
      });
      return checkedDetails;
    },
    // 提交表单（带校验）
    submit() {
      if (this.isSubmitting) return;
      const checkedCount = this.getCheckedCount();
      if (checkedCount < 1) {
        this.$message.warning("请至少勾选1个选项！");
        return;
      }

      // 关键：调用表单校验
      this.$refs.demandForm.validate(async (valid) => {
        if (valid) {
          // 校验通过，提交接口
          try {
            this.isSubmitting = true;
            const params = {
              demandContent: this.resetForm.demandContent,
              linkman: this.resetForm.linkman,
              companyName: this.resetForm.companyName,
              contactInfo: this.resetForm.contactInfo,
              checkContent: this.getCheckedDetails(),
            };
            // 替换为你的实际接口
            const res = await insert(params);
            if (res.code === 0) {
              this.$message.success(res.msg || "提交成功！");
              this.$refs.demandForm.resetFields(); // 重置表单
              this.homeMessage.list.forEach((item) => {
                item.list.forEach((issue) => (issue.checked = false));
              });
            } else {
              this.$message.warning(res.msg || "提交失败，请重试");
            }
          } catch (error) {
            console.error("提交失败：", error);
            this.$message.error("网络异常，请稍后重试");
          } finally {
            this.isSubmitting = false;
          }
        } else {
          // 校验失败：Element UI 会自动给错误字段加红色边框+提示
          this.$message.warning("请完善表单信息并检查格式！");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.layout-footer {
  height: 564px;
  background: #eff4fb;
  .footerbackground {
    background-image: url("../../assets/footerimg.png");
    background-repeat: no-repeat; /* 防止背景图重复 */
    background-size: cover; /* 背景图自适应容器大小 */
    background-position: center; /* 背景图居中显示 */
  }
  .container {
    width: 1320px;
    margin: 67px auto 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 60px;
  }

  .l {
    flex: 1;
    .contact {
      font-weight: bold;
      font-size: 24px;
      color: #000a25;
    }
    li {
      color: #000219;
      font-size: 16px;
      margin-top: 32px;

      &:first-child {
        margin-top: 0;
      }
    }
  }

  .right-col {
    width: 651px;
  }

  .information {
    display: flex;
    margin-top: 20px;
  }

  /* 调整输入框和按钮样式，保持原有布局 */
  .information .el-form-item {
    margin-right: 20px;
  }

  .information .el-form-item:last-child {
    margin-right: 0;
  }

  .information .el-input {
    width: 160px;
    height: 32px;
  }

  .information .el-button {
    width: 160px;
    height: 40px;
    /* 确保按钮和输入框对齐 */
  }

  /* 可选：自定义错误提示样式（如需调整红色提示框） */
  ::v-deep .el-form-item__error {
    color: #f56c6c; /* Element UI 默认错误色，可修改 */
    font-size: 12px;
    margin-top: 4px;
  }

  /* 错误输入框边框颜色（Element UI 默认已为红色，如需强化） */
  ::v-deep .el-form-item.is-error .el-input__inner {
    border-color: #f56c6c !important;
    box-shadow: 0 0 0 1px rgba(245, 108, 108, 0.2) !important;
  }

  /* 底部导航和二维码的父容器（关键：flex布局实现同一水平线） */
  .bottom-group {
    width: 100%; /* 占满整行宽度 */
    display: flex;
    align-items: center; /* 垂直居中对齐 */
    justify-content: space-between; /* 两端对齐，导航居左，二维码居右 */
    margin-top: 40px; /* 与上方内容拉开距离 */
  }

  /* 底部导航 */
  .footer-nav {
    display: flex;
    gap: 30px; /* 导航项之间的间距 */
    align-items: flex-end;
    margin-top: 30px;
    a {
      font-weight: bold;
      font-size: 16px;
      color: #000a25;
    }
  }

  /* 二维码区域 */
  .qr-group {
    display: flex;
    gap: 40px; /* 二维码之间的间距 */
    margin-top: 30px;
    .qr-item {
      text-align: center;
      img {
        width: 76.85px;
        height: 76.85px;
      }
      p {
        margin-top: 10px;
        color: #858a9d;
        font-size: 14px;
      }
    }
  }

  .record {
    margin-left: 10px;
    > img {
      width: 16px;
      vertical-align: middle;
    }
  }
  .copyright {
    background: #f6f9fd;
    font-size: 12px;
    color: #858a9d;
    line-height: 40px;
    text-align: center;
    margin-top: 20px;
  }
}
.demand-form .checkbox-container {
  height: 199px;
  background: #f8fafd;
  border-radius: 4px;
  border: 1px solid #d3d3e2;
  padding: 12px;
  display: flex;
  gap: 12px; /* 卡片之间的间距（原4px太窄，调整为12px更美观） */
  overflow: hidden; /* 隐藏超出容器的内容 */
}

/* 核心：每个卡片平均分成5份 */
.demand-form .center-card {
  flex: 1; /* 关键属性：自动均分父容器宽度 */
  min-width: 0; /* 解决 flex 子元素最小宽度限制（避免内容撑宽） */
  padding: 8px 12px;
  border-radius: 4px;
  box-sizing: border-box; /* 确保 padding 不影响宽度计算 */
}

.demand-form .center-title {
  margin-bottom: 12px;
  font-weight: bold;
  font-size: 14px;
  color: #000a25;
  white-space: nowrap; /* 标题不换行 */
  overflow: hidden; /* 溢出隐藏 */
  text-overflow: ellipsis; /* 溢出显示省略号 */
}

/* 勾选框列表：控制高度，溢出滚动 */
.demand-form .checkbox-list {
  max-height: calc(199px - 40px); /* 父容器高度 - 标题+内边距高度，避免超出 */
  overflow-y: auto; /* 垂直溢出时显示滚动条 */
}

.demand-form .checkbox-item {
  margin-left: 8px; /* 原20px太宽，调整为8px更紧凑 */
  margin-bottom: 10px;
  font-size: 13px;
  color: #333;
  white-space: nowrap; /* 勾选框文字不换行 */
  overflow: hidden;
  text-overflow: ellipsis; /* 文字溢出显示省略号 */
}

/* 美化滚动条（可选） */
.demand-form .checkbox-list::-webkit-scrollbar {
  width: 4px;
}
.demand-form .checkbox-list::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 2px;
}
</style>
